import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {repoRouteBuilder} from '../config/repo-route-builder'
import type {CommitsPayload} from '../types/commits-types'

export function buildCommitsRefRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('commitsRefRoute', {
    path: '/:owner/:repo/commits/:ref/*',
    queries: [
      mainQuery<CommitsPayload>({
        queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
      }),
    ],
  })
}

export const commitsRefRoute = buildCommitsRefRoute(repoRouteBuilder)
